import { Flex } from '@applyboard/crystal-ui';

import { PageHeader } from '../../../components/PageHeader';
import { SelectedIntakesBar } from '../components';
import {
  CampusFilter,
  IntakeFilter,
  IntakesFilterSummary,
  IntakesPagination,
  QueryFilter,
  Sort,
  IntakesTable,
  StatusFilter,
} from '~/components/Intake';

export function TabletLayout() {
  return (
    <Flex p={10} gap={3} direction="column">
      <PageHeader title="Intake Management" />
      <Filter as={<QueryFilter />} width="100%" />
      <Flex gap={2}>
        <Filter as={<CampusFilter />} width="25%" />
        <Filter as={<IntakeFilter />} width="25%" />
        <Filter as={<StatusFilter />} width="25%" />
        <Filter as={<Sort />} width="25%" />
      </Flex>
      <Flex pt={2}>
        <IntakesFilterSummary />
      </Flex>
      <SelectedIntakesBar />
      <IntakesTable />
      <IntakesPagination />
    </Flex>
  );
}

function Filter(props: { as: React.ReactNode; width: string }) {
  return <div style={{ width: props.width }}>{props.as}</div>;
}
